import React, { useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RichTextEditor = ({ termsAndConditions, setTermsAndConditions }) => {
  const quillRef = useRef(null);

  useEffect(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor(); // Get Quill instance
    //   editor.focus(); // Focus on editor to apply formatting

      // Select all content and apply bullet formatting
      editor.setSelection(0, editor.getLength());
      editor.format("list", "bullet");
      editor.setSelection(null)
    }
  }, []); // Runs when content updates

  return (
    <ReactQuill
      ref={quillRef}
      value={termsAndConditions}
      onChange={setTermsAndConditions}
      modules={{
        toolbar: [
          [{ list: "bullet" }], // Only bullet list option
          ["bold", "italic", "underline"],
          ["clean"],
        ],
      }}
      formats={["list", "bullet", "bold", "italic", "underline"]}
      placeholder="Enter bullet points here..."
    />
  );
};

export default RichTextEditor;